import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { User } from './models/User'
import { fetchUserInfo } from './thunks/fetchUserInfo'

export const initialState: User = {
  clientName: '',
  menus: [],
  groups: [],
  client: {
    moniker: '',
    name: '',
    id: -1,
    businessModel: 1,
    isOnboarded: false,
  },
  userType: 100,
  defaultGroupId: -1,
  importSheetSelection: false,
  clientId: -1,
  name: '',
  login: '',
  id: -1,
  isActive: false,
}

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setBusinessModel: (state, action: PayloadAction<User['businessModel']>) => {
      state.businessModel = action.payload
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserInfo.fulfilled, (_, action) => {
        return action.payload as User
      })
  },
})

export const { setBusinessModel } = userSlice.actions